import React from "react";

const FILTVHeader = ({ user }) => {
    return (
        <div className="bg-zinc-950/95 backdrop-blur border-b border-zinc-800 sticky top-0 z-40">
            <div className="flex justify-between items-center px-3 py-2.5">
                <div>
                    <div className="text-xl sm:text-2xl font-bold text-purple-400 leading-none">
                        📺 FiLTV
                    </div>
                    <div className="text-[10px] text-zinc-500 mt-1">FindItLocal TV</div>
                </div>

                <div className="text-right">
                    <div className="text-green-400 text-[10px] font-semibold animate-pulse">
                        ● LIVE
                    </div>
                    {user?.name && (
                        <div className="text-white text-sm leading-tight">{user.name}</div>
                    )}
                    <div className="text-[10px] text-zinc-500">Powered by Think5Whys</div>
                </div>
            </div>
        </div>
    );
};

export default FILTVHeader;
